import { Tab, Tabs } from "react-bootstrap";
import CadastrarContato from "./CadastrarContato";
import VincularContaContato from "./VincularContaContato";

interface ICadastrarContatoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    idConta: number;
}

export default function CadastrarContaContato(props: ICadastrarContatoProps) {
    return (
        <Tabs defaultActiveKey="cadastrar">
            <Tab title="Cadastrar Contato" eventKey="cadastrar">
                <CadastrarContato {...props} />
            </Tab>
            <Tab title="Vincular existente" eventKey="vincular">
                <VincularContaContato {...props} />
            </Tab>
        </Tabs>
    );
}
